import { Selectors3asFPermissions, selectAllowUpgrade, selectStpLimit } from '@va/aaas/shared/selectors';
import { PlanIndexes, PlanNames } from '@va/constants';
import { startUpgradeProcess } from '@va/dashboard/actions/app';
import { getCurrentPlanName } from '@va/dashboard/selectors/app';
import { UpgradePlanTooltipComponent } from '@va/dashboard/ui/components';
import { useLocale, useTranslate } from '@va/localization';
import { setUpgradePlanIndex } from '@va/standalone/shared/actions';
import { hasPermission } from '@va/standalone/shared/selectors';
import { addNumberSeparator } from '@va/util/helpers';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SegmentsUpgradeTooltipImage } from './SegmentsUpgradeTooltipImage';

export const UpgradePlanTooltip = () => {
  const dispatch = useDispatch();
  const translate = useTranslate();
  const activePlanName = useSelector(getCurrentPlanName);
  const hasUpgradePermission = useSelector(hasPermission);

  return (
    <UpgradePlanTooltipComponent
      requiredPlanText={translate('all.upgradePlanTooltip.requiredPlan', { planName: PlanNames.Pro })}
      currentPlanText={translate('all.upgradePlanTooltip.currentPlan', { planName: activePlanName })}
      title={translate('all.upgradePlanTooltip.segments.title')}
      text={translate('all.upgradePlanTooltip.segments.text')}
      image={<SegmentsUpgradeTooltipImage />}
      onUpgradeClick={() => {
        if (!hasUpgradePermission) return;
        dispatch(setUpgradePlanIndex(PlanIndexes.Pro));
        dispatch(startUpgradeProcess());
      }}
    />
  );
};

export const AaasMinCreditsTooltip = () => {
  const translate = useTranslate();
  const stpLimit = useSelector(selectStpLimit);
  const minStps = useSelector(Selectors3asFPermissions.limit.visitorSegments);
  const allowUpgrade = useSelector(selectAllowUpgrade);
  const dispatch = useDispatch();
  const { locale } = useLocale();
  const hasInfiniteCredits = useMemo(() => stpLimit === -1, [stpLimit]);

  const onIntpUpgrade = useCallback(() => {
    dispatch(startUpgradeProcess());
  }, [dispatch]);

  return (
    <UpgradePlanTooltipComponent
      requiredPlanText={translate('aaas.requiredCreditsCount', { count: addNumberSeparator(minStps, locale) })}
      currentPlanText={translate('aaas.currentCreditsCount', {
        count: hasInfiniteCredits ? '∞' : addNumberSeparator(stpLimit, locale),
      })}
      title={translate('all.upgradePlanTooltip.segments.title')}
      text={translate('all.upgradePlanTooltip.segments.text')}
      image={<SegmentsUpgradeTooltipImage />}
      onUpgradeClick={allowUpgrade ? onIntpUpgrade : undefined}
    />
  );
};
